import request from '@/utils/request'

const integralAbnormalReport = {
  name: 'integralAbnormalReport',
  state: {
    integralAbnormalReportDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_integralAbnormalReport_DETAIL_LOADING: (state, data) => {
      state.isintegralAbnormalReportDetailLoading = data
    },
    SET_MODULES_integralAbnormalReport_DETAIL_DATA: (state, data) => {
      state.integralAbnormalReportDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryintegralAbnormalReportDetailData({ commit }, id) {
      commit('SET_IS_MODULES_integralAbnormalReport_DETAIL_LOADING', true)
      commit('SET_MODULES_integralAbnormalReport_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/integralAbnormalReport/integralAbnormalReportDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_integralAbnormalReport_DETAIL_LOADING', false)
          commit('SET_MODULES_integralAbnormalReport_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_integralAbnormalReport_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetintegralAbnormalReportDetailData({ commit }) {
      commit('SET_MODULES_integralAbnormalReport_DETAIL_DATA', {})
    },
    setintegralAbnormalReportDetailData({ commit }, data) {
      commit('SET_MODULES_integralAbnormalReport_DETAIL_DATA', data)
    }
  }
}

export default integralAbnormalReport
